(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rounded-tiktok-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rounded-tiktok-videos')) {
    customElements.define('rounded-tiktok-videos', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        if (!this.querySelector('.rtv__track')) {
          this.connectFrame = requestAnimationFrame(() => { if (this.isConnected) this.connectedCallback(); });
          return;
        }
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.track = this.querySelector('.rtv__track');
        this.cards = [...this.querySelectorAll('[data-card]')];
        this.videos = [...this.querySelectorAll('video')];
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.dots = this.querySelector('[data-dots]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = new Set();
        this.manualPaused = new WeakSet();
        this.manualStarted = new WeakSet();
        this.pending = new WeakSet();
        this.pages = [];
        this.frame = 0;
        this.scrollFrame = 0;
        this.motion.addEventListener('change', () => this.syncPlayback(), { signal });
        document.addEventListener('visibilitychange', () => this.syncPlayback(), { signal });
        this.videos.forEach(video => {
          const card = video.closest('[data-card]');
          video.setAttribute('aria-label', card.getAttribute('aria-label'));
          video.controls = false;
          video.muted = true;
          const update = () => {
            card.querySelector('[data-paused]').hidden = !video.paused;
            card.querySelector('[data-playing]').hidden = video.paused;
            card.querySelector('[data-play]').setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
            card.querySelector('[data-muted]').hidden = !video.muted;
            card.querySelector('[data-audible]').hidden = video.muted;
            card.querySelector('[data-mute]').setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
            card.querySelector('[data-mute]').setAttribute('aria-pressed', String(video.muted));
          };
          ['play','pause','volumechange','ended'].forEach(name => video.addEventListener(name, update, { signal }));
          video.addEventListener('playing', () => {
            card.querySelector('[data-status]').textContent = '';
            if (!this.shouldPlay(video)) video.pause();
          }, { signal });
          video.addEventListener('error', () => { card.querySelector('[data-status]').textContent = 'Video unavailable'; }, { signal });
          video.addEventListener('timeupdate', () => {
            const fraction = Number.isFinite(video.duration) && video.duration > 0 ? video.currentTime / video.duration : 0;
            card.querySelector('[data-progress]').style.transform = 'scaleX(' + fraction + ')';
          }, { signal });
          update();
        });
        this.addEventListener('click', event => {
          const control = event.target.closest('[data-play],[data-mute]');
          if (!control || !this.contains(control)) return;
          const video = control.closest('[data-card]').querySelector('video');
          if (!video) return;
          if (control.hasAttribute('data-play')) {
            if (video.paused) {
              if (video.ended) video.currentTime = 0;
              this.manualPaused.delete(video);
              this.manualStarted.add(video);
              this.visible.add(video);
              this.start(video);
            } else {
              this.manualPaused.add(video);
              this.manualStarted.delete(video);
              video.pause();
            }
          } else {
            const willUnmute = video.muted;
            if (willUnmute) document.querySelectorAll('rounded-tiktok-videos video').forEach(other => { if (other !== video) other.muted = true; });
            video.muted = !willUnmute;
          }
        }, { signal });
        this.prev?.addEventListener('click', () => this.navigate(-1), { signal });
        this.next?.addEventListener('click', () => this.navigate(1), { signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.navigate(event.key === 'ArrowRight' ? 1 : -1); }
        }, { signal });
        this.track.addEventListener('scroll', () => {
          if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = 0; this.updateNavigation(); });
        }, { signal, passive:true });
        this.dots?.addEventListener('click', event => {
          const dot = event.target.closest('[data-page]');
          if (dot) this.go(Number(dot.dataset.page));
        }, { signal });
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting && entry.intersectionRatio >= .55) this.visible.add(entry.target);
            else { this.visible.delete(entry.target); this.manualStarted.delete(entry.target); entry.target.pause(); entry.target.muted = true; }
          });
          this.syncPlayback();
        }, { threshold:[0,.55,1] });
        this.videos.forEach(video => this.observer.observe(video));
        this.resize = new ResizeObserver(() => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.measure());
        });
        this.resize.observe(this.track);
        this.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.blockId === event.detail.blockId);
          if (card) this.track.scrollTo({ left:card.offsetLeft - this.cards[0].offsetLeft, behavior:'instant' });
        }, { signal });
        this.classList.add('is-ready');
        this.measure();
      }
      start(video) {
        if (!video.paused || this.pending.has(video) || video.ended && !video.loop) return;
        const promise = video.play();
        if (!promise) return;
        this.pending.add(video);
        promise.catch(error => {
          if (error.name === 'AbortError') return;
          const status = video.closest('[data-card]').querySelector('[data-status]');
          status.textContent = error.name === 'NotAllowedError' ? 'Tap play to watch' : 'Unable to play video';
        }).finally(() => this.pending.delete(video));
      }
      syncPlayback() {
        this.videos.forEach(video => {
          if (this.shouldPlay(video)) this.start(video);
          else { video.pause(); if (document.hidden) video.muted = true; }
        });
      }
      shouldPlay(video) {
        const autoplay = this.dataset.autoplay === 'true' && !(this.dataset.reduceMotion === 'true' && this.motion.matches);
        return !document.hidden && this.visible.has(video) && !this.manualPaused.has(video) && (autoplay || this.manualStarted.has(video));
      }
      measure() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const origin = this.cards[0]?.offsetLeft || 0;
        this.pages = [...new Set([0,...this.cards.map(card => Math.min(max, Math.max(0, card.offsetLeft - origin)))].map(value => Math.round(value)))];
        if (this.dots) {
          this.dots.replaceChildren(...this.pages.map((position,index) => {
            const button = document.createElement('button');
            button.type = 'button'; button.className = 'rtv__dot'; button.dataset.page = index;
            button.setAttribute('aria-label', 'Go to video position ' + (index + 1));
            button.setAttribute('aria-controls', this.track.id);
            return button;
          }));
          this.dots.hidden = max < 2;
        }
        if (this.prev) this.prev.hidden = max < 2;
        if (this.next) this.next.hidden = max < 2;
        this.updateNavigation();
      }
      currentPage() {
        return this.pages.reduce((best,value,index) => Math.abs(value - this.track.scrollLeft) < Math.abs(this.pages[best] - this.track.scrollLeft) ? index : best, 0);
      }
      updateNavigation() {
        const current = this.currentPage();
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
        this.dots?.querySelectorAll('button').forEach((button,index) => button.setAttribute('aria-current', String(index === current)));
      }
      go(index) {
        const target = Math.max(0, Math.min(this.pages.length - 1,index));
        this.track.scrollTo({ left:this.pages[target] || 0, behavior:this.motion.matches ? 'instant' : 'smooth' });
      }
      navigate(direction) { this.go(this.currentPage() + direction); }
      disconnectedCallback() {
        this.abort?.abort(); this.abort = null;
        this.observer?.disconnect(); this.resize?.disconnect();
        cancelAnimationFrame(this.connectFrame);
        cancelAnimationFrame(this.frame); cancelAnimationFrame(this.scrollFrame);
        this.videos?.forEach(video => { video.pause(); video.controls = true; });
        this.classList.remove('is-ready');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
